import { useSelector } from "react-redux";

import DeleteIcon from "../../static/image/deleteIcon.svg";
import CustomInput from "../../components/customInput/CustomInput";

function Product({
  templateList,
  language,
  onInputChange,
  onShowUploadFile,
  onShowDeleteFile,
}) {
  const productState = useSelector((state) => state.product);
  const error = productState.error;
  const product = productState.data || {};
  const topIntroduction = product.topIntroduction || {};

  return (
    <>
      <div className="tab-package-container">
        {templateList.map((template, index) => {

          if (template.type === "text") {
            return (
              <div style={{ position: 'relative' }} key={index}>
                <div className="package-input">
                  <label>
                    {template.label}
                    {template.required && (
                      <span className="required-asterisk">*</span>
                    )}
                    :
                  </label>
                  <CustomInput
                    type="text"
                    value={topIntroduction[template.id] || ""}
                    onChange={(e) =>
                      onInputChange(template.id, e.target.value, language)
                    }
                    placeholder={template.placeholder[language]}
                    customStyle={{ width: "73%" }}
                    error={error?.[template.id]}
                  />

                </div>

              </div>
            );
          }

          if (template.type === "textarea") {
            return (
              <div key={index} className="package-input">
                <label>
                  {template.label}
                  {template.required && (
                    <span className="required-asterisk">*</span>
                  )}
                  :
                </label>
                <textarea
                  value={topIntroduction[template.id] || ""}
                  onChange={(e) =>
                    onInputChange(template.id, e.target.value, language)
                  }
                  placeholder={template.placeholder[language]}
                ></textarea>
              </div>
            );
          }

          if (template.type === "file") {
            return (
              <div style={{ position: 'relative' }} key={index}>
                <div className="package-input">
                  <label>
                    {template.label}
                    {template.required && (
                      <span className="required-asterisk">*</span>
                    )}
                    :
                  </label>
                  <input
                    type="text"
                    placeholder={template.placeholder[language]}
                    value={topIntroduction[template.id] || ""}
                    onChange={(e) => onInputChange(template.id, e.target.value)}
                    disabled
                  />
                  {!topIntroduction[template.id] && (
                    <button
                      className="upload-btn"
                      onClick={() => onShowUploadFile(template.id)}
                    >
                      Upload
                    </button>
                  )}
                  {topIntroduction[template.id] && (
                    <button
                      className="icon-btn"
                      onClick={() => onShowDeleteFile(template.id)}
                    >
                      <img
                        src={DeleteIcon}
                        alt="Delete"
                        className="action-icon"
                      />
                    </button>
                  )}

                </div>
                {topIntroduction[template.id] && (
                  <div style={{ marginLeft: '190px', marginBottom: '20px' }}>
                    <img
                      src={`https://uat.stack-ez.com${topIntroduction[template.id]}`}
                      alt="Preview"
                      style={{ maxWidth: '200px', maxHeight: '200px', marginTop: '10px' }}
                    />
                  </div>
                )}
              </div>
            );
          }

          return null;
        })}
      </div>
    </>
  );
}

export default Product;